module.exports = __webpack_public_path__ + "static/media/editIcon.1b60c06a.svg";